<template>
  <Btn :label="$t('ELE0036')" :disabled="disabled" icon="mdi-delete" isCheckRole @click="onClick" />
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'

export default {
  name: 'BtnDelete',
  components: {
    Btn,
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
